module.exports = __webpack_public_path__ + "img/08-0销售效能管理.f2ea9be0.png";